import DiagonalArrow from '@components/icons/DiagonalArrow.svg';
import { routes } from '@routes';
import { usePageContext } from '../../../../../../providers/PageProvider';
import { AdminJobTopActionButton } from '@components/core-ui/form-elements/buttons/Button/variations/AdminJobTopActionButton';

export const TranscriptPlayerButton = () => {
  const { job } = usePageContext();

  if (!job) {
    return null;
  }

  const transcriptPlayerUrl = routes.adminJobTranscriptPlayer.make(job.id);

  return (
    <AdminJobTopActionButton
      title="Open Transcript Player"
      onClick={() => window.open(transcriptPlayerUrl, '_blank', 'noopener,noreferrer')}
      className="min-w-[140px]"
    >
      <DiagonalArrow />
      Transcript Player
    </AdminJobTopActionButton>
  );
};
